<script lang="ts">
  import { SWITCH_IDS, TICK_HZ } from "@spacecrew/shared";
  import { ship } from "../net/ship.svelte.js";
  import { send } from "../net/intents.js";
  import SurgeHandle from "./SurgeHandle.svelte";

  const snap = $derived(ship.snap!);
  const b = $derived(snap.breakers);
  const live = $derived(snap.phase === "running" && b.status === "tripped");
  const lockS = $derived(Math.max(0, (b.untilTick - snap.tick) / TICK_HZ));
</script>

<div class="console">
  <h3>BREAKER BAY — PANEL 1</h3>
  <p aria-live="polite">
    {#if b.status === "idle"}<span class="dim">ALL BREAKERS NOMINAL.</span>
    {:else if b.status === "lockout"}<span class="bad">PROCEDURE DEVIATION — PANEL LOCKED {lockS.toFixed(1)} s</span>
    {:else}<span class="warn">FAULT — RESET IN SEQUENCE. {b.flipped.length} / {b.required.length} ACCEPTED.</span>{/if}
  </p>
  <p class="dim">PROCEDURE: SEE BRIDGE CONSOLE. DO NOT GUESS.</p>
  <div class="switches" role="group" aria-label="Breaker switches">
    {#each SWITCH_IDS as id}
      <button disabled={!live} aria-pressed={b.flipped.includes(id)} onclick={() => send("toggle.flip", { switchId: id })}>{id}</button>
    {/each}
  </div>
  {#if snap.activeEvent === "coolant"}
    <div class="leak">
      <h3>COOLANT LOOP 2 — BYPASS VALVE B</h3>
      <p class="warn">LEAK ACTIVE. VALVE A IS AT REACTOR CONTROL. BOTH MUST BE HELD UNTIL SEALED.</p>
      <SurgeHandle task="coolant" handleId="B" verb="SEALING" />
    </div>
  {/if}
</div>

<style>
  .console { display: grid; gap: 0.6rem; border: 1px solid var(--fg-dim); padding: 0.7rem; }
  .switches { display: grid; grid-template-columns: repeat(4, minmax(0, 1fr)); gap: 0.5rem; }
  .switches button { min-height: 72px; font-size: 1.3em; }
  .leak { border-top: 1px solid var(--warn); padding-top: 0.6rem; display: grid; gap: 0.4rem; }
</style>
